
'use client';

import React from 'react';

export default function MatrixGrid() {
    return (
        <div>
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute inset-0"></div>
            </div>
            <div
                className="absolute inset-0 bg-[linear-gradient(rgba(0,255,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,255,0,0.05)_1px,transparent_1px)] bg-[size:40px_40px] animate-[pulse_6s_infinite] pointer-events-none"></div>

        </div>
    );
}